var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-viewable-item",class:{'bc-viewable-item--disabled':_vm.disabled}},[_c('EditIcon',{attrs:{"icon":"View"},on:{"execute":_vm.view}}),_c('span',{on:{"click":_vm.view}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }